import React, { Component } from 'react';
class DashboardFooter extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {

  }

  render() {
    return (
        <>
          {/*<!-- Footer Start -->*/}
        <div className="container-fluid bg-dark text-white-50 footer wow fadeIn" data-wow-delay="0.1s">
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-12 text-center mb-3 mb-md-0">
                            &copy; <a className="border-bottom" href="/"><b>Bylaws</b> India</a>, All Right Reserved.             

                        </div>

                    </div>
                </div>
            </div>
        </div>
        {/*<!-- Footer End -->*/}



        </>
    );
  }
}

export default DashboardFooter;
